module.exports = {
  "country": "LU",
  "artist": "Vicky Leandros",
  "song": "Après Toi",
  "year": "1972",
  "place": "1",
  "spotify": "13tx9je0ftBgu6BKpsQDo4"
};